<template>
    <v-row class="align-center">
        <div>
            <v-btn icon @click="likePost(post)" small>
                <v-icon v-if="!post.liked">mdi-heart-outline</v-icon>
                <v-icon v-else color="red">mdi-heart</v-icon>
            </v-btn>
            
            <router-link tag="span" 
            :to="likesLink"
            class="subtitle-2"
            append
            replace
            v-if="likesLink"
            >{{`${post.likes_count} ${post.likes_count > 1 ? 'Likes' : 'Like'}`}}</router-link>
            <span 
            class="subtitle-2"
            v-else
            @click="$emit('likesClick', post.id)">{{`${post.likes_count} ${post.likes_count > 1 ? 'Likes' : 'Like'}`}}
            </span>
        </div>

        <div class="ml-1" v-if="comments">
            <v-btn icon class="ml-0" :to="`/post/${post.id}/comments/`" small>
                <v-icon>mdi-comment-text-outline</v-icon>
            </v-btn>
            <span class="subtitle-2">{{ `${post.comments_count} ${post.comments_count > 1 ? 'Comments' : 'Comment'}` }}</span>
        </div>

        <div class="ml-1">
            <v-btn icon class="ml-0" small>
                <v-icon>mdi-eye-outline</v-icon>
            </v-btn>
            <span class="subtitle-2">{{ `${post.views_count} ${post.views_count > 1 ? 'Views' : 'View'}` }}</span>
        </div>

        <v-spacer></v-spacer>
        <v-btn icon @click="save(post)" :disabled="saveLoading" :loading="saveLoading">
            <v-icon v-if="post.saved" color="success">mdi-bookmark</v-icon>
            <v-icon v-else>mdi-bookmark-outline</v-icon>
        </v-btn>
    </v-row>
</template>
<script>
import mixinPost from "@/mixins/mixin-post"
export default {
    mixins: [mixinPost],
    props: {
        post: Object,
        likesLink: String,
        comments: {
            type: Boolean,
            default: true
        }
    }
}
</script>